import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=f42a90e4"
import script from "./LanguageButton.vue?vue&type=script&lang=ts"
export * from "./LanguageButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports